import { useEffect, useState } from "react";
import { domain, token } from "../../Security";
import axios from "../../../api/apiClient";

export const AccessTemplateIdSelect = ({ 
  accessTemplateId, 
  setAccessTemplateId, 
  label, 
  isRequired = false,
  error = false,
  errorMessage = ""
}) => {
  const [isSelected, setIsSelected] = useState(false);
  const [accessTemplates, setAccessTemplates] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/AccessTemplate";
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      setAccessTemplates(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
    if (accessTemplateId !== "" && accessTemplateId !== 0 && accessTemplateId !== undefined) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [accessTemplateId]);

  const hasNoData = accessTemplates.length === 0;

  return (
    <div className="mb-1 w-full">
      {/* Label matching standardize design */}
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-gray-600">
          {label}
          {isRequired && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}

      <select
        value={accessTemplateId || ""}
        onChange={(e) => setAccessTemplateId(e.target.value)}
        disabled={hasNoData}
        className={`w-full box-border border border-solid border-gray-300 rounded-md px-3 py-2 text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white 
          ${error ? "border-red-500" : ""} 
          ${hasNoData ? "bg-gray-100 cursor-not-allowed text-gray-400" : ""}
          ${!isSelected ? "text-gray-400" : "text-gray-700"}`}
      >
        {hasNoData ? (
          <option value="" disabled hidden>-- No Available AccessTemplate --</option>
        ) : (
          <option value="" disabled hidden>Choose access template</option>
        )}

        {accessTemplates.map((item, index) => (
          <option key={index} value={item.id} className="text-gray-700">
            {item.id} - {item.description}
          </option>
        ))}
      </select>

      {/* Error message matching standardize design */}
      {error && errorMessage && (
        <span className="mt-1 block text-sm text-red-500">{errorMessage}</span>
      )}
    </div>
  );
};